import Vue from 'vue'
import Vuei18n from 'vue-i18n'
// import messages from '../components/translations'

Vue.use(Vuei18n)

function loadLocaleMessages () {
  const locales = require.context('../components/translations/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

export const i18n = new Vuei18n({
  locale: 'th',
  fallbackLocale: 'th',
  messages: loadLocaleMessages()
})

// export const i18n = new VueI18n({
//   locale: 'th',
//   fallbackLocale: 'th',
//   messages
// })
